export const routes = {
  services: {
    mep: ["mechanical", "electrical", "plumbing"],
    inspections: ["progress", "special"],
    "fire protection": ["sprinkler", "standpipe", "fire alarm"],
    architectural: [],
    structural: [],
    expediting: [],
    consulting: [],
  },
  projects: {
    featured: [],
    "by status": ["current", "completed"],
    "by location": [
      "manhattan",
      "brooklyn",
      "queens",
      "bronx",
      "staten island",
      "other"
    ],
    "by client": ["residential", "commercial"],
  },
  pricing: {},
  team: {
    principals: [],
    architects: [],
    engineers: [],
    inspectors: [],
    consultants: [],
  },
  about: {
    company: ["history", "mission"],
    awards: [],
    partners: [
      "architects",
      "engineers",
      "expediters",
      "inspectors",
      "contractors",
      "surveyors",
    ],
  },
  contact: {
    connect: ["visit us", "call us", "email us"],
    "send rfp": [],
    "media inquiries": [],
    "investor relations": [],
    franchising: [],
    careers: [],
  },
  login: {},
  admin: {},
};
